import type { MeetingsDict } from '../en/meetings';

export const meetings: MeetingsDict = {
  drawer: {
    title: 'Möten',
    connectTitle: 'Anslut din kalender',
    connectDescription:
      'När kalendern är ansluten deltar Queri automatiskt i alla dina kalendermöten för att spela in, föra anteckningar och ta fram sammanfattningar.',
    connecting: 'Ansluter …',
    or: 'eller',
    upcoming: 'Kommande möten',
    past: 'Tidigare möten',
    noUpcoming: 'Inga kommande möten',
    noPast: 'Inga tidigare möten',
    settings: 'Mötesinställningar',
    fetchStatusFailed: 'Det gick inte att hämta kalenderstatus',
    oauthFailed: 'Det gick inte att starta inloggningen',
    popupBlocked:
      'Det gick inte att öppna inloggningsfönstret. Tillåt popup-fönster för den här webbplatsen.',
    connected: (provider: string) => `${provider} är nu ansluten!`,
    timedOut: 'Anslutningen tog för lång tid. Försök igen.',
  },
  settings: {
    title: 'Mötesinställningar',
    assistant: 'Mötesassistent',
    assistantDescription: 'Delta i och spela in dina möten automatiskt',
    disconnect: 'Koppla från',
    confirmDisconnect: 'Ja, koppla från',
    disconnecting: 'Kopplar från …',
    noCalendar: 'Ingen kalender att koppla från hittades',
    disconnectFailed: 'Det gick inte att koppla från kalendern',
    updateAssistantFailed: 'Det gick inte att uppdatera mötesassistenten',
  },
  botStatus: {
    scheduled: 'Schemalagt',
    recording: 'Spelar in',
    joining: 'Ansluter',
    recorded: 'Inspelat',
    ready: 'Klart',
  },
  detail: {
    notFound: 'Mötet hittades inte',
    loadFailed: 'Det gick inte att läsa in mötesinformationen',
    error: 'Fel',
    goBack: 'Gå tillbaka',
    backToMeetings: 'Tillbaka till möten',
    recording: 'Inspelning',
    videoUnsupported: 'Din webbläsare har inte stöd för videouppspelning.',
    recordingUnavailable: 'Inspelningen är inte tillgänglig',
    recordingUnavailableHint: 'Inspelningen kan ha raderats eller håller fortfarande på att bearbetas.',
    processing: 'Bearbetar',
    processingDescription:
      'Mötessammanfattningen håller på att tas fram. Titta tillbaka om några minuter.',
    summaryFailed: 'Sammanfattningen kunde inte tas fram',
    summaryFailedDescription: 'Ett fel uppstod när sammanfattningen skulle tas fram.',
    summary: 'Sammanfattning',
    keyTopics: 'Huvudpunkter',
    actionItems: 'Åtgärdspunkter',
    general: 'Allmänt',
    contractDetected: 'Avtal identifierat',
    confidence: (percent: number) => `${percent} % säkerhet`,
    parties: 'Parter',
    keyTerms: 'Centrala villkor',
    notSpecified: 'Ej angivet',
    contractGenerated: 'Avtal skapat',
    contractId: (id: string) => `Avtals-ID: ${id}`,
    findInDrafts: 'Du hittar det bland dina utkast.',
    generationFailed: 'Det gick inte att skapa avtalet',
    generateContractFailed: 'Det gick inte att skapa avtalet',
    generatingContract: 'Skapar avtal …',
    generateContract: 'Skapa avtalsutkast',
    emailActions: 'E-poståtgärder',
    emailRecipient: 'E-postmeddelandet skickas till:',
    includeContract: 'Bifoga avtalet',
    emailSent: 'E-post skickad',
    emailSentDescription: (email: string) =>
      `Mötessammanfattningen har skickats till ${email}`,
    emailFailed: 'E-postmeddelandet kunde inte skickas',
    sendEmailFailed: 'Det gick inte att skicka e-postmeddelandet',
    sendingEmail: 'Skickar e-post …',
    sendEmail: 'Skicka sammanfattning via e-post',
    noSummary: 'Ingen sammanfattning tillgänglig',
    noSummaryDescription: 'Någon sammanfattning har ännu inte tagits fram för det här mötet.',
  },
  contractDocument: {
    defaultType: 'Avtalsdokument',
    generated: (docType: string) =>
      `Ett dokument (${docType}) har tagits fram utifrån det här mötet. Du kan förhandsgranska det eller ladda ner en kopia.`,
    preview: 'Förhandsgranska',
    download: 'Ladda ner',
    downloading: 'Laddar ner …',
    previewTitle: (docType: string) => `Förhandsgranskning: ${docType}`,
    previewDescription: (docType: string) =>
      `Skrivskyddad förhandsgranskning av det framtagna dokumentet (${docType}).`,
    loadingPreview: 'Läser in förhandsgranskning …',
    previewFailed: 'Det gick inte att läsa in förhandsgranskningen',
    close: 'Stäng',
  },
};
